import { siteTitle } from '@repo/config';
import type { AppSidebarData } from '@repo/ui';
import { Monitor, User } from 'lucide-react';
import { Mark } from '@/components/logo';
import {
  getAccountNavItems,
  getMyNavItems,
  getSysNavItems,
  getSysToolItems,
  type ISysToolItem,
} from './helper';

export type DashboardSidebarData = AppSidebarData & { navTools?: ISysToolItem[] };

interface ISidebarDataParams {
  user: AppSidebarData['user'];
  isAdmin: boolean;
  pathname?: string;
}

const branding: AppSidebarData['branding'] = {
  title: siteTitle,
  logo: Mark,
  href: '/',
};

export function getMySidebarData({ user, isAdmin }: ISidebarDataParams): DashboardSidebarData {
  return {
    user,
    branding,
    navMain: getMyNavItems(),
    navSecondary: isAdmin ? [{ title: 'System', url: '/sys', icon: Monitor }] : undefined,
  };
}

export function getDashboardSidebarData({
  user,
  isAdmin,
  pathname,
}: ISidebarDataParams): DashboardSidebarData {
  return {
    user,
    branding,
    navMain: getSysNavItems({ pathname, isAdmin }),
    navSecondary: [{ title: 'My Account', url: '/my', icon: User }],
    navTools: isAdmin ? getSysToolItems() : undefined,
  };
}

export function getAccountSidebarData({ user, isAdmin }: ISidebarDataParams): DashboardSidebarData {
  const navSecondary: NonNullable<AppSidebarData['navSecondary']> = [
    { title: 'My Account', url: '/my', icon: User },
  ];

  if (isAdmin) {
    navSecondary.push({ title: 'System', url: '/sys', icon: Monitor });
  }

  return {
    user,
    branding,
    navMain: getAccountNavItems(),
    navSecondary,
  };
}
